import { useMutation } from "@apollo/client";

import { MapEditorGetAllLayerFeaturesDocument } from "~/modules/mapEditor/api/useMapEditorGetAllLayerFeatures.generated";
import { MapEditorFeatureListRoute_QueryDocument } from "~/modules/mapEditor/routes/MapEditorFeatureListRoute/queries.generated";

import { MapEditorPlannerAreaPanel_PlannerAreaDeleteDocument } from "../../mutations.generated";

export function useDeletePlannerAreaMutation() {
    const [mutate, result] = useMutation(MapEditorPlannerAreaPanel_PlannerAreaDeleteDocument, {
        refetchQueries: [MapEditorFeatureListRoute_QueryDocument, MapEditorGetAllLayerFeaturesDocument],
        awaitRefetchQueries: true,
    });

    const deletePlannerArea = (featureId: string) =>
        mutate({
            variables: {
                input: {
                    featureId,
                },
            },
        });

    return [deletePlannerArea, result] as const;
}
